import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const animateBlocks = gsap.utils.toArray('.block-animate')

function initLazy() {

  const lazyImages = document.querySelectorAll('[data-lazy-src]')

  ScrollTrigger.create({
    trigger: 'body',
    start: 'top+=20 top',
    end: 'top+=200 top',
    once: true,
    //markers: true,
    onEnter: () => {
      lazyImages.forEach(image => {
        const src = image.getAttribute('data-lazy-src')
        image.setAttribute('src', src)
      })
    }
  })

}

initLazy()

function initContentAnimations() {

  if (animateBlocks.length) {

    let startVal = 'top +=85%'
    let endVal = 'bottom -=85%'

    if(window.innerWidth < 700) {
      startVal = 'top +=85%'
      endVal = 'bottom -=85%'
    }

    animateBlocks.forEach((block, i) => {

      const content = block.querySelectorAll('.block-animate-content')

      ScrollTrigger.create({
        trigger: block,
        start: startVal,
        end: endVal,
        once: true,
        //markers: true,
        onEnter: () => {
          gsap.fromTo(block, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 })
          gsap.fromTo(content, { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, delay: 0.2, duration: 0.4, stagger: 0.1 })
        }
      })

    })
  }

}

$(window).on('load', function () {



  setTimeout(function () {
    $('body').removeAttr('style')

  }, 50)

  if (animateBlocks.length) {
    animateBlocks.forEach((block, i) => {

      gsap.set(block, { autoAlpha: 0 })

      const content = block.querySelectorAll('.block-animate-content')

      gsap.set(content, { autoAlpha: 0, y: 50 })

    })
  }



  setTimeout(function () {

    initContentAnimations()

  }, 150)

})
